import styled from 'styled-components';
import { Header } from '@playbookux/playbook-web-core';

export const Message = styled(Header)`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const UploadMessage = styled(Header)`
  display: flex;
  text-align: center;
  margin-bottom: 20px;
  color: #192c47;
`;

export const InProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 350px;
  width: 100%;
  margin-top: 100px;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  max-width: 600px;
`;

export const ClockImage = styled.img`
  margin-bottom: 10px;
  width: 55px;
`;

export const List = styled.ul`
  list-style-position: inside;
  margin-bottom: 40px;
`;

export const ListItem = styled.li`
color: ${({ theme }) => theme.color.textSecondary};
font-size: ${({ theme }) => theme.fontSize.text};
margin-bottom: 12px;
`;

export const TextNoResults = styled.text`
  color: #192C47;
  font-size: 18px;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100vh;
  flex: 1;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;
